import { Component } from '@angular/core';

@Component({
    selector: 'app-test',
    template: '<div i18n="@@test">Dit is een placeholder. Hier moet later iets anders komen.</div>',
    standalone: false,
})
export class TestComponent {}
